var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 20,
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 10.625,
  cy: 10,
  r: 9,
  stroke: "black",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.2469 9.85849L14.2466 9.85865L14.2469 9.85849ZM14.0328 10L8.89768 13.3958L8.89768 6.60429L14.0328 10ZM14.2466 10.1414L14.2469 10.1416L14.2466 10.1414Z",
  stroke: "black",
  strokeWidth: 2
})));
export default SvgIconPlay;